/*
api アクセス先のリスト
 */
const api = {
  login: '/api/login', // No.1
  logout: '/api/logout', // No.2
  tempPassword: '/api/temp-password', // No.3
  password: '/api/password', // No.4
  partnerCompanies: '/api/partner-companies', // No.5
  applicationInstitutions: '/api/application-institutions', // No.6,7,9
  applicationInstitutionsOpen: '/api/application-institutions-open', // No.8
  medicalInstitutions: '/api/medical-institutions', //No.12
  stripeClientId: '/api/stripe-client-id', //No.13
  stripeStandardAccounts: '/api/stripe-standard-accounts', // No.14
  stripeConnects: '/api/stripe-connects', // No.15 path:/{access_key}
  bankTransferSettings: '/api/bank-transfer-settings', // No.17,18,19
  teamsClientId: '/api/teams-client-id', //No.50
  teamsConnections: '/api/teams-connections', //No.51, 53 path:/{department_id}
  teamsMeetings: '/api/teams-meetings', //  No.52 path:{{reservation_id or access_key}
  zoomClientId: '/api/zoom-client-id', //No.20
  zoomConnections: '/api/zoom-connections', //No.21, 45 path:/{department_id}
  videoMeetings: '/api/video-meetings', //  No.22 path:{{reservation_id or access_key}
  departmentSettings: '/api/department-settings', // No.23, No.24 path:/{department_id}
  departmentDisplayOrder: '/api/department-display-order', // No.27 path:/{department_id}
  verificationEmail: '/api/verification-email', // No. 29
  verificationSms: '/api/verification-sms', // No. 79
  reservationMedicalInstitutions: '/api/reservation-medical-institutions', // No.30 path:/{institution_access_key}
  reservationFrames: '/api/reservation-frames', // No.31 path:/{department_id},
  reservableDates: '/api/reservable-dates', // No.80 path:/{department_id},
  reservations: '/api/reservations', // No.32 path:/{reservation_id or access_key}, No.38, No.39 path:/{reservation_id or access_key}
  reservationIds: '/api/reservation-ids', // No.40 path:{access_key}
  reservationRemind: '/api/reservation-remind', // No.61 path:{id}
  resendInstitutionMail: '/api/application-institutions-email', // No.62 path:{institution_id}
  publicInformation: '/api/site-publication-informations', // No.65
  /**
   * 画像取得
   */
  reservationAttachmentImages: '/api/reservation-attachment-images', // No.34 path:/{reservation_id or access_key}
  reservationIdentityVerificationImages:
    '/api/reservation-identity-verification-images', // No.35 path:/{reservation_id or access_key}
  reservationInsuranceCardImages: '/api/reservation-insurance-card-images', // No.36 path:/{reservation_id or access_key}
  reservationCertificateImages: '/api/reservation-certificate-images', // No.37 path:/{reservation_id or access_key}

  reservationsCall: '/api/reservations-call', // No.41 path:{reservation_id}
  reservationCancel: '/api/reservation-cancel', // No.42 path:{reservation_id or access_key}
  billings: '/api/billings', // No.43 path:/{reservation_id}, No.44
  /**
   * 仮予約
   */
  preReservations: '/api/provisional-reservations', // No.51, No.52 path:{provisional_reservation_id or provisional_reservation_access_key}
  /**
   * 連絡先
   */
  contactEmails: '/api/contact-emails', // No.59, No.60
  /**
   * 申し込みプラン
   */
  entryPlanDirect: '/api/application-plans-direct', // No.63
  entryPlanPartner: '/api/application-plans-partner', // No.64
  /**
   * 処方設定
   */
  prescriptionMedicines: '/api/prescription-medicines', //No.67,68
  nearPharmacies: '/api/near-pharmacies', //No.69,70
  pharmacies: '/api/pharmacies', //No.71
  googleMapsApiKey: '/api/google-maps-api-key', //No.78
  /**
   * 住所変更
   */
  reservationsApplicantAddress: '/api/reservations-applicant-address', // No.77 path:{reservation_id}
  /**
   * 日時変更
   */
  reservationsDatetime: '/api/reservations-datetime', // No.82 path:{id}
  /**
   * 医療機関へのお知らせ
   */
  informationToMed: '/api/information-to-medical-Institutions', // No.83
  /**
   * GET: ログイン中の医療機関、または、予約対象医療機関のオンライン資格確認用URLを取得（No.85）
   * PUT: ログイン中の医療機関のオンライン資格確認用URLを更新（No.86）
   */
  onlineEligibilityVerificationUrl: '/api/online_eligibility_verification_url',
  /**
   * GET: ログイン中の医療機関、または、予約対象医療機関のオンラインオンライン資格確認アプリ固有IDを取得（No.84）
   */
  onlineEligibilityVerificationAppId:
    '/api/online_eligibility_verification_app_id',
}

/*
json post送信option生成
 */
export const postApiOptions = (data: object) => {
  const method = 'POST'
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  const body = JSON.stringify(data)
  return { method, headers, body }
}

/*
json put送信option生成
 */
export const putApiOptions = (data?: object) => {
  const method = 'PUT'
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  const body = data && JSON.stringify(data)
  return { method, headers, body }
}

/*
json delete送信option生成
 */
export const deleteApiOptions = () => {
  const method = 'DELETE'
  return { method }
}

export type ApiErrorTypes =
  | 'validation_error'
  | 'server_error'
  | 'connection_error'
  | 'infected_error'

/**
 * APIから返ってくるエラー
 */
export type ApiErrorResponseBodyProps = {
  type: ApiErrorTypes
  values: ApiErrorValuesProps
}

export type ApiErrorValuesProps = {
  [name: string]: Array<ApiValidationErrorProps | ApiServerErrorProps | string>
}

export type ApiValidationErrorProps =
  | 'unique' // admin_user.email  ユーザーのメールアドレスが重複する
  | 'exists' // access_key:access_keyが存在しない、または有効期限が切れている, reservation_id:reservation_idが存在しない, call_method, settlement_method
  | 'capacity' // reservation_datetime_start:予約枠が埋まっている,
  | 'valid' // pass_code:パスコードが有効期限切れ
  | 'correct' // pass_code:パスコードが不正, old_password:old_passwordが不正
  | 'mime_type' // 画像の形式が不正
  | 'cancel' // キャンセルされている場合
  | 'reserved' // 予約済み
  | 'billed' // 請求済み

export type ApiServerErrorProps =
  | 'send' // email メール送信失敗
  | 'numbering' // reservation_number 予約IDの採番に失敗

export default api
